<template>

    <div class="empty">

        <div class="bloc">

            <img src="/img/newsletters-v2/mailbox-empty.svg">

            <h1 class="title">{{ $t('cleaning_clean_title') }}</h1>

            <p class="text">{{ $t('cleaning_list_end') }}</p>

            <button class="cta-add"
                    @click="goAddInbox">
                {{ $t('cleaning_done_add_mailbox_cta') }}
            </button>

            <button class="cta-stats"
                    @click="goStats">
                {{ $t('cleaning_list_cta_stat') }}
            </button>
        </div>

    </div>

</template>

<script>
import Tag from '@/modules/tag'

export default {

    name: 'newsletters-v2-empty',

    props: {
        category: {
            type: String,
            default: ''
        }
    },

    mounted() {
        Tag.pageViewGA(this, 'cleaning_done')
    },

    methods: {
        goAddInbox() {
            Tag.clickGA(this, 'add_inbox')
            this.$router.push({path: '/add-inbox'})
        },

        goStats() {
            Tag.clickGA(this, 'see_stats')
            this.$router.push({path: '/stats'})
        }
    }
}
</script>

<style lang="scss" scoped>

.empty {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 90px 16px 24px;
    background-color: $cultured;
    text-align: center;
    @media screen and (min-width: $above-tablet-length) {
        padding: 16px 32px 32px;
    }

    .bloc {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 463px;

        > img {
            height: 80px;
            object-fit: contain;
            @media screen and (min-width: $above-tablet-length) {
                height: 96px;
            }
        }

        .circle {
            width: 40px;
            height: 40px;
            background-color: $white;
            border-radius: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            > img {
                width: 16px;
                object-fit: contain;
            }
        }

        .title {
            margin-top: 16px;
            font-size: 17px;
            font-weight: 600;
            line-height: 1.41;
            color: $midnight;
        }

        .text {
            margin-top: 8px;
            font-size: 15px;
            font-weight: 500;
            line-height: 1.33;
            color: $moon;
        }

        button {
            padding: 16px 40px;
            width: 100%;
            border-radius: 32px;
            text-align: center;
            font-size: 17px;
            font-weight: 600;
            line-height: 1.41;
            @media screen and (min-width: $above-tablet-length) {
                max-width: 308px;
            }
        }

        .cta-add {
            margin-top: 24px;
            background-color: $midnight;
            color: $white;
        }

        .cta-stats {
            margin-top: 8px;
            background-color: $white;
            color: $charcoal;
        }
    }
}
</style>
